export default __webpack_public_path__ + "static/media/how-to-win.98136f96.mp3";